module.exports = __webpack_public_path__ + "static/media/shopping-cart.7675d0fb.svg";